/*
  Copyright (c) 2018-present, Accuracy.
  All rights reserved.
*/

/**
 * Resolves a path under the `public/` folder (e.g. `'files/img/foo.jpg'`) to
 * an absolute URL honouring the app's homepage prefix (`process.env.PUBLIC_URL`,
 * derived from `homepage` in `package.json` — currently `/`, so this is a no-op
 * in production, but keeps asset resolution correct if the app is ever served
 * from a sub-path again, or from a nested route with a router `basename`).
 *
 * Plain relative paths (`src={'files/img/foo.jpg'}`) look correct but are
 * resolved by the browser against the *current page path*, not the app root —
 * they silently break on any route whose URL, after dropping its last
 * segment, doesn't land back on the site root (e.g. `/` itself under a
 * router `basename`).
 */
export const asset = (path: string): string => `${process.env.PUBLIC_URL}/${path.replace(/^\/+/, '')}`;
